import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Divider, Button } from '@mui/material';
import { fetchNews, fetchSavedNewsIds, saveNews, unsaveNews } from '../lib/api';
import NewsCard from './NewsCard';

const NewsList = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [filteredSite, setFilteredSite] = useState(null);
  const [savedNewsIds, setSavedNewsIds] = useState([]); // ✅ 保存済み記事ID
  const limit = 10;

  // 🔹 初回とSITEフィルタ変更時にニュースと保存データ取得
  useEffect(() => {
    loadNews(0, true);
  }, [filteredSite]);
  
  useEffect(() => {
    loadSavedNews();
  }, []); // ← 初回マウント時に限定
  

  const loadNews = async (pageNum, reset = false) => {
    try {
      const data = await fetchNews(pageNum, limit, filteredSite);
      setNews((prevNews) => {
        if (reset) return data;
        return [...prevNews, ...data.filter(article => !prevNews.some(prev => prev.id === article.id))];
      });
      setPage(pageNum);
    } catch (error) {
      console.error("ニュースの取得に失敗しました:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 保存済みニュースを取得
  const loadSavedNews = async () => {
    const ids = await fetchSavedNewsIds();
    setSavedNewsIds(ids);
  };

  // 🔹 SITE_NAMEでフィルタ
  const filterBySite = (siteName) => {
    setFilteredSite((prevSite) => (prevSite === siteName ? null : siteName));
  };

  // ✅ ハートボタン押下で保存/解除を切り替える
  const handleToggleSave = async (article) => {
    const isAlreadySaved = savedNewsIds.includes(article.id);

    try {
      if (isAlreadySaved) {
        await unsaveNews(article.id);
        setSavedNewsIds((prev) => prev.filter((id) => id !== article.id));
      } else {
        await saveNews(article.id);
        setSavedNewsIds((prev) => [...prev, article.id]);
      }
    } catch (err) {
      console.error("保存/解除に失敗:", err);
    }
  };

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="body1">ニュースを読み込み中...</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      {filteredSite ? (
        <>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {filteredSite} のニュース
          </Typography>
          <Button variant="outlined" onClick={() => setFilteredSite(null)} sx={{ mb: 2 }}>
            フィルタ解除
          </Button>
        </>
      ) : (
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          AI News 速報
        </Typography>
      )}

      {news.map((article, index) => (
        <Box key={article.id}>
          <NewsCard
            article={article}
            selectedSite={filteredSite}
            onFilterBySite={filterBySite}
            isSaved={savedNewsIds.includes(article.id)} // ✅ ハート状態を渡す
            onSaveArticle={handleToggleSave}
          />
          {index !== news.length - 1 && <Divider sx={{ my: 2 }} />}
        </Box>
      ))}

      <Button variant="contained" sx={{ mt: 3 }} onClick={() => loadNews(page + 1)}>
        次の10件を見る
      </Button>
    </Container>
  );
};

export default NewsList;
